/* eslint-disable max-len */
import * as React from 'react';
import {
  Divider, IconButton, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Tooltip,
} from '@mui/material';
import { useSelector } from 'react-redux';
import StoreIcon from '@mui/icons-material/Store';
import LogoutIcon from '@mui/icons-material/Logout';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import { useNavigate } from 'react-router-dom';
import RoutePath from 'app/router/RoutePath';
import { resetJwt } from 'features/login/state/reducer';
import store from 'app/store';
import { Drawer, DrawerHeader } from 'common/components/navigatorComponents';
import { AFLAC } from 'common/Constants';
import { CLIENT_PORTAL_URL_LOGOUT, IDEA_PORTAL_URL, IDEA_PORTAL_BROKER_URL } from 'common/AppConstant';
import ChevronleftIcon from '@mui/icons-material/ChevronLeft';
import CancelScenarioDialog from 'features/scenario/common/cancelScenarioDialog';
import { updateFormState, toggleClearRefresh } from 'features/scenario/state/reducer';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import { toggleSideBar } from './state/reducer';

export default function SideBar() {
  const navigate = useNavigate();
  const carrierCode = useSelector((state) => state.auth.carrierCode);
  const sideBarOpen = useSelector((state) => state.navigator.sideBarOpen);
  const formStateValue = useSelector((state) => state.scenario.isModified);
  const brokerCode = useSelector((state) => state.auth?.brokerCode);
  const [path, setPath] = React.useState(false);
  const [cancelDialogOpen, setCancelDialogOpen] = React.useState(false);
  const ideasPortalUrl = brokerCode ? IDEA_PORTAL_BROKER_URL : IDEA_PORTAL_URL;

  const toggleMenu = () => {
    store.dispatch(toggleSideBar());
  };

  const navigateTo = (link, screen) => {
    if (screen || !formStateValue) {
      setCancelDialogOpen(false);
      store.dispatch(updateFormState(false));
      navigate(link);
      setPath(false);
    } else {
      setCancelDialogOpen(true);
      setPath(link);
    }
  };

  const logout = (screen) => {
    if (screen || !formStateValue) {
      setCancelDialogOpen(false);
      localStorage.clear();
      store.dispatch(resetJwt());
      if (carrierCode === AFLAC.CODE) {
        navigate(RoutePath.aflacLogin.path);
      } else {
        window.location.replace(CLIENT_PORTAL_URL_LOGOUT);
      }
      store.dispatch(updateFormState(false));
    } else {
      setCancelDialogOpen(true);
    }
  };

  const cancelScenarioClose = () => {
    setCancelDialogOpen(false);
  };

  return (
    <Drawer
      variant="permanent"
      open={sideBarOpen}
      sx={{
        flexShrink: 0,
      }}
    >
      <DrawerHeader>
        <IconButton onClick={() => toggleMenu()}>
          <ChevronleftIcon />
        </IconButton>
      </DrawerHeader>
      <List>
        <ListItem disablePadding sx={{ display: 'block' }}>
          <Tooltip title="Home" placement="right">
            <ListItemButton onClick={() => {
              navigateTo(RoutePath.app.scenario.path);
              store.dispatch(toggleClearRefresh());
            }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: sideBarOpen ? 3 : 'auto',
                  justifyContent: 'center',
                }}
              />
              <StoreIcon />
              <ListItemText primary="Home" sx={{ opacity: sideBarOpen ? 1 : 0, marginLeft: '7px' }} />
            </ListItemButton>
          </Tooltip>
          <Tooltip title="User Guides" placement="right">
            <ListItemButton onClick={() => { navigateTo(RoutePath.app.guides.path); }}>
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: sideBarOpen ? 3 : 'auto',
                  justifyContent: 'center',
                }}
              />
              <MenuBookIcon />
              <ListItemText primary="User Guides" sx={{ opacity: sideBarOpen ? 1 : 0, marginLeft: '7px', marginTop: '5px' }} />
            </ListItemButton>
          </Tooltip>
          {/* <Tooltip title="FAQ" placement="right">
            <ListItemButton onClick={() => { navigateTo(RoutePath.app.faq.path); }}>
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: sideBarOpen ? 3 : 'auto',
                  justifyContent: 'center',
                }}
              />
              <QuizIcon />
              <ListItemText primary="FAQ" sx={{ opacity: sideBarOpen ? 1 : 0, marginLeft: '7px', marginTop: '5px' }} />
            </ListItemButton>
          </Tooltip> */}
          <Tooltip title="Your ideas matter! Click to share." placement="right">
            <ListItemButton onClick={() => { window.open(ideasPortalUrl, '_blank'); }}>
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: sideBarOpen ? 3 : 'auto',
                  justifyContent: 'center',
                }}
              />
              <LightbulbIcon />
              <ListItemText primary="Ideas" sx={{ opacity: sideBarOpen ? 1 : 0, marginLeft: '7px', marginTop: '5px' }} />
            </ListItemButton>
          </Tooltip>
        </ListItem>
      </List>
      <Divider />
      <List>
        <ListItem disablePadding sx={{ display: 'block' }}>
          <Tooltip title="Logout" placement="right">
            <ListItemButton onClick={() => logout()}>
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: sideBarOpen ? 3 : 'auto',
                  justifyContent: 'center',
                }}
              />
              <LogoutIcon />
              <ListItemText primary="Logout" sx={{ opacity: sideBarOpen ? 1 : 0, marginLeft: '7px' }} />
            </ListItemButton>
          </Tooltip>
        </ListItem>
      </List>
      <CancelScenarioDialog
        logout={logout}
        navigateTo={navigateTo}
        path={path}
        isOpen={cancelDialogOpen}
        onClose={() => cancelScenarioClose(false)}
      />
    </Drawer>
  );
}
